import React from 'react';
import moment from "moment";
import { useSelector } from "react-redux";
import { Dialog, DialogTitle, Grid, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const useStyles = makeStyles((theme) => ({
    root:{
        marginLeft: "auto",
        marginRight: "auto",
    },
    header:{
        background: '#68389F',
        color:'white'
      },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
}));

const WEEKDAYS_SHORT = [
    'DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB',
];

const WEEKDAYS_LONG = [
    'Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado',
];

const MONTHS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const ModalCalendarioDiaEventual = ({open, setOpen, title, transformDay, selectedDate, setSelectedDay, setSelectedDate}) => {
    const classes = useStyles();
    const { items } = useSelector((state) => state.feriados);
    const startDate = moment();

    const disabledDays = [
        {
            // before: moment(moment()).add(1, 'days').toDate(),        //dia actual mas 1 como minimo
            after: new Date(startDate.year(), startDate.month(), 0),
            before: moment().toDate(),
        }
        , ...items.map(s => new Date(s.feriado))
    ];

    const handleDayClick = (day, { selected }) => {
        setSelectedDate(day)
        setSelectedDay(transformDay((day).getDay()));
        closeModal();
    }

    const closeModal = () => {
        setOpen(false);
    }
    
    return ( 
        <>
            <Dialog
                maxWidth="sm"
                open={open}
                onClose={closeModal}
            >
                <DialogTitle className={classes.header}>
                    <Toolbar >
                        <Typography variant="h6" >
                            {title}
                        </Typography>
                    </Toolbar>
                </DialogTitle>
                <div className={classes.root}>
                    <Grid container >
                        <Grid item xs={12} md={4} >
                            <DayPicker
                                month={moment({ year: startDate.year(), month: startDate.month() }).toDate()}
                                fromMonth={moment({ year: startDate.year(), month: startDate.month() }).toDate()}
                                toMonth={moment({ year: startDate.year() + 1, month: 11 }).toDate()}
                                disabledDays={disabledDays}
                                selectedDays={selectedDate}
                                onDayClick={handleDayClick}
                                //localization
                                locale={'esp'}
                                months={MONTHS}
                                firstDayOfWeek={1}
                                weekdaysLong={WEEKDAYS_LONG}
                                weekdaysShort={WEEKDAYS_SHORT}
                            />
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
        </>
     );
}
 